import React from "react";
import { RootElement } from "./src/templates/providers";
import "./global.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/mulish/400.css";
import "@fontsource/mulish/700.css";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <RootElement>{element}</RootElement>;
};
